import alt from 'components/Dispatcher';

class BrowserActions {
  constructor() {
    this.generateActions('getTimezone', 'setLastActive');
  }
}

export default alt.createActions(BrowserActions);
